module.exports = __webpack_public_path__ + "media/images/sort_asc-c98bfc42ca4ded066bab874c8a67677d.png";